import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/Modal";
import { Table } from "components/Table";
import { CoinHandIcon, HelpIconGrey } from "assets/icons";
import { columns } from "./columns";
import {
  HeaderContent,
  IconWrapper,
  ModalTitle,
  ModalDescription,
  SummarySection,
  SummaryTitle,
  SummaryDescription,
  HoldingsSection,
  HoldingsTitle,
  Divider,
} from "./AllHoldingsModal.styles";

const AllHoldingsModal = ({ isOpen, onClose, holdings }) => {
  const holdingsData = holdings || [];
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      heading={
        <HeaderContent>
          <IconWrapper>
            <img src={CoinHandIcon} alt="Holdings" width={24} height={24} />
          </IconWrapper>
          <div>
            <ModalTitle>All holdings</ModalTitle>
            <ModalDescription>
              Summary of the compositions of this strategy
            </ModalDescription>
          </div>
        </HeaderContent>
      }
    >
      <SummarySection>
        <SummaryTitle>Summary</SummaryTitle>
        <SummaryDescription>
          This strategy primarily focuses on industries such as technology and
          health technology, offering a diverse range of opportunities. It
          serves as an ideal investment approach for investors seeking
          short-term returns and who are prepared to embrace higher risks.
        </SummaryDescription>
      </SummarySection>

      <Divider />

      <HoldingsSection>
        <HoldingsTitle>
          Holdings
          <img src={HelpIconGrey} alt="Help" />
        </HoldingsTitle>
        <Table
          data={holdingsData}
          columns={columns}
          showPagination={false}
          showEntriesText={false}
        />
      </HoldingsSection>
    </Modal>
  );
};

AllHoldingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  holdings: PropTypes.arrayOf(
    PropTypes.shape({
      company_name: PropTypes.string,
      asset: PropTypes.string,
      share_price: PropTypes.number,
      performance_1y_percent: PropTypes.number,
      industry: PropTypes.string,
    })
  ),
  strategyName: PropTypes.string,
};

export default AllHoldingsModal;
